/**
 * Monitors cart updates and removes preparation products whose linked bat
 * variant is no longer in the cart. Links are stored as the hidden line item
 * property `_preparation_for` (set when the prep item is added to cart).
 */

let processing = false;

async function syncPrepItems() {
  if (processing) return;
  processing = true;

  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const items = cart.items ?? [];

    const variantIdsInCart = new Set(items.map((item) => String(item.variant_id)));

    const orphanedKeys = items
      .filter((item) => {
        const linkedVariant = item.properties?.['_preparation_for'];
        return linkedVariant && !variantIdsInCart.has(String(linkedVariant));
      })
      .map((item) => item.key);

    if (orphanedKeys.length === 0) return;

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: Object.fromEntries(orphanedKeys.map((key) => [key, 0])),
      }),
    });

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: 'cart-prep-linker' } },
      })
    );
  } catch (error) {
    console.error('[cart-prep-linker] Error syncing prep items:', error);
  } finally {
    processing = false;
  }
}

document.addEventListener('cart:update', (event) => {
  const source = /** @type {CustomEvent} */ (event).detail?.data?.source;
  // Avoid reacting to our own dispatched event
  if (source === 'cart-prep-linker') return;
  syncPrepItems();
});
